var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHelp = function SvgHelp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.3,
    y: 22.6,
    width: 3.4,
    height: 1.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.3,
    y: 0.1,
    width: 3.4,
    height: 1.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 10.3,
    width: 1.3,
    height: 3.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22.7,
    y: 10.3,
    width: 1.3,
    height: 3.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,23.6C5.6,23.6,0.4,18.4,0.4,12S5.6,0.4,12,0.4c6.4,0,11.6,5.2,11.6,11.6S18.4,23.6,12,23.6z M12,1 C6,1,1,6,1,12C1,18,6,23,12,23c6,0,11-4.9,11-11C23,6,18,1,12,1z M12,17.7c-3.1,0-5.7-2.6-5.7-5.7c0-3.1,2.6-5.7,5.7-5.7 c3.1,0,5.7,2.6,5.7,5.7C17.7,15.1,15.1,17.7,12,17.7z M12,6.9c-2.8,0-5.1,2.3-5.1,5.1c0,2.8,2.3,5.1,5.1,5.1c2.8,0,5.1-2.3,5.1-5.1 C17.1,9.2,14.8,6.9,12,6.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6,17.2c-0.5,0.2-1.1,0.3-1.6,0.3c-0.6,0-1.1-0.1-1.7-0.3c-1,1.1-2.1,4.7-1.7,5.6c1.1,0.3,2.2,0.5,3.4,0.5 c1.2,0,2.3-0.2,3.4-0.5C15.7,21.6,14.8,18.4,13.6,17.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4,1.3c-1.1-0.3-2.2-0.5-3.4-0.5c-1.2,0-2.3,0.2-3.4,0.5c-0.3,0.9,0.7,4.5,1.7,5.6c0.5-0.2,1.1-0.3,1.7-0.3 c0.6,0,1.1,0.1,1.6,0.3C14.8,5.6,15.7,2.4,15.4,1.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7,8.6c-0.9-0.3-4.5,0.7-5.6,1.7c0.2,0.5,0.3,1.1,0.3,1.7c0,0.6-0.1,1.1-0.3,1.6c1.2,1.1,4.4,2,5.6,1.7 c0.3-1.1,0.5-2.2,0.5-3.4C23.3,10.8,23.1,9.7,22.7,8.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8,10.4c-1.1-1-4.7-2.1-5.6-1.7C0.9,9.7,0.7,10.8,0.7,12c0,1.2,0.2,2.3,0.5,3.4c1.1,0.3,4.4-0.6,5.6-1.7 c-0.2-0.5-0.3-1.1-0.3-1.6C6.6,11.4,6.7,10.9,6.8,10.4z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHelp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help.e9a1461d.svg";
export { ForwardRef as ReactComponent };